import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"display":"flex","padding-top":"20px"} }
const _hoisted_4 = { class: "dialog-footer ml-20 mb-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_BusinessList = _resolveComponent("BusinessList")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_BusinessList, {
      showStateFilter: true,
      showDefaultCommand: false,
      ref: "BusinessListRef",
      approvalParams: {
        modify: 2,
        changeStatus: 1
      },
      formDisabled: true,
      businessTypeName: "TABLE_APPROVAL_CANCEL_BUSINESS",
      FilterFieldProps: _ctx.FilterField
    }, {
      command: _withCtx(({ scope }) => [
        _createVNode(_component_el_link, {
          href: "javascript:void(0);",
          class: "mr-10",
          type: "primary",
          onClick: ($event: any) => (_ctx.handleApproval(scope))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" 审批取消 ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["FilterFieldProps"]), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormComponent, {
              id: _ctx.activeId,
              initFormData: _ctx.initFormData,
              fromFieldData: _ctx.originFromFieldData,
              dialogFormVisible: _ctx.dialogFormVisible,
              api: 'business',
              isShowCloseBtn: false,
              isShowSubmitBtn: false,
              formDisabled: true
            }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogFormVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.submitLoading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSubmit('approve')))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" 通过 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, {
              type: "danger",
              loading: _ctx.submitLoading,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSubmit('reject')))
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" 拒绝 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}